import React from 'react'
import PropTypes from 'prop-types'
import { IndexLink, Link } from 'react-router'
import MenuButton from '../../../components/MenuButton'
import Avatar from 'material-ui/Avatar';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import AvatarDefault from './user-circle.png'
import LoadingOverlay from '../../../components/LoadingOverlay'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import Snackbar from 'material-ui/Snackbar'
import config from 'config'
const style = {
	userInfo: {
		float: 'left',
		clear: 'both',
		marignTop: config.language.key == 'sp' ? '4px': '0px'
	},
	menuStyle : {
		fontSize: '10px',
		fontFamily: 'Open Sans',
		color: '#8a949b'
	},
	avatar: {
		width: '24px',
		height: '24px',
		backgroundSize: 'cover',
		borderRadius: '50%'
	}
}

function isLoading(main) {
  return main && main.loading && main.loading > 0
}

export const Main = ({ children, main, translate , logout }) => (
<div>
    {isLoading(main) ? <LoadingOverlay /> : ''}
  	<div>
  		<Snackbar
			open={main && main.snackBar && main.snackBar.open ? main.snackBar.open : false}
			message={main && main.snackBar && main.snackBar.message ? main.snackBar.message : " "}
			style={{
				left : "200px",
				bottom : "20px"
			}}
  		/>
	  	<div className='main-header'
	  		style={{
	  			height: config.language.key == 'sp' ? '58px': '48px'
	  		}}
	  	>
	  		{main.doctor ? (
	  			<IconMenu
	  				style = {{
						float: 'left',
						clear: 'both',
						marginTop: config.language.key == 'sp' ? '4px': '0px'
					}}
					iconButtonElement={
						<MenuItem className="header-menu-item" primaryText={main.doctor.email}
							style={style.menuStyle}
							rightIcon={<ArrowDropDown />}
							leftIcon={
								<div style={{...style.avatar, backgroundImage: main.doctor.avt ? `url(${encodeURI(main.doctor.avt)})` : `url(${AvatarDefault})`}} />
							}
						/>
					}
					anchorOrigin={{horizontal: 'right', vertical: 'top'}}
      				targetOrigin={{horizontal: 'right', vertical: 'top'}}
		        >
					<MenuItem value="3" primaryText={translate('Logout')}
						onClick={() => {
							logout();
						}}
					/>
		        </IconMenu>
	  		) : ('')}
			<Link to='/' >
				<div className='home' />
			</Link>
	  		<div className='header-button-group'>
		  		<MenuButton
		  			href='/match'
		  			type='match'
		  			text={translate('Match_Tests')}
		  		/>
		  		<MenuButton
		  			href='/status'
		  			type='status'
		  			badge= {true}
		  			text={translate('Update_Status')}
		  		/>
		  		<MenuButton
		  			href='/setting'
		  			type='setting'
		  			text={translate('Settings')}
		  		/>
				{localStorage.admin === 'true' ? (
                    <MenuButton
                        href='/admin'
                        type='admin'
                        text={translate('Super_Admin')}
                    />
				) : ('')}
	  		</div>
			<div className="mobile-button-group">
				<IconMenu
					iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}
					targetOrigin={{horizontal: 'right', vertical: 'top'}}
					anchorOrigin={{horizontal: 'right', vertical: 'top'}}
				>
					<MenuItem primaryText={translate('Match_Tests')} containerElement={<Link to="/match"></Link>} />
					<MenuItem primaryText={translate('Update_Status')} containerElement={<Link to="/status"></Link>} />
					<MenuItem primaryText={translate('Settings')} containerElement={<Link to="/setting"></Link>} />
                    {localStorage.admin === 'true' ? (
					<MenuItem primaryText={translate('Super_Admin')} containerElement={<Link to="/admin"></Link>} />
                    ) : ('')}
				</IconMenu>
			</div>
	  	</div>
	  	<div className='main-body'>
		  	{children}
	  	</div>
	  	<div className='main-footer text-center'>
	  		<div className='inline-block'>
	  			<div className='inline-block'>
				  <p><a href={translate('footer_link')} target="_blank">&copy; Hera 
				  Biotech {(new Date().getFullYear())}</a></p>
				</div>
	  		</div>
	  	</div>
  	</div>
</div>
)
Main.propTypes = {
  children: PropTypes.node,
  main: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
}

export default Main



// WEBPACK FOOTER //
// ./src/routes/Main/components/Main.js